import React, { useState, useEffect } from 'react';
import {object, func, bool} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {useEntidad} from '../../hooks/useEntidad';
import {isEmptyString, isValidNumber, OnKeyPress_validInteger} from '../../../utils/validator';
import {Accordion, DatePickerCustom, FormError, FormLabel, InputEntidad, InputLista, InputNumber, InputSubTasa, InputTasa, Modal} from '../../common';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import DataTaggerFormRedux from '../DataTaggerFormRedux';

const EspacioArrendadoModal = (props) => {

    const entityInit = {
        id: 0,
        idComercio: 0,
        idTipoArrendamiento: 0,
        numero: "",
        bloque: "",
        fechaVigenciaDesde: null,
        fechaVigenciaHasta: null,
        fechaBaja: null,
        superficie: 0,
        longitud: 0,
        idTipoConsumoElectrico: 0,
        cantidadArtefactosElectricos: 0,
        numeroResolucion: "",
        nombreEmbarcacion: "",
        matriculaEmbarcacion: "",
        idTasaEmbarcacion: 0,
        idSubTasaEmbarcacion: 0,
        eslora: 0,
        manga: 0,
        puntal: 0,
        pesoNeto: 0,
        pesoBruto: 0,
        pesoLastre: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        esEmbarcacion: false,
        list: [],
    });

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoArrendamiento'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoArrendamiento',
            timeout: 0
        }
    });

    const mount = () => {
        formSet({
            idTipoArrendamiento: props.data.entity.idTipoArrendamiento,
            numero: props.data.entity.numero,
            bloque: props.data.entity.bloque,
            fechaVigenciaDesde: props.data.entity.fechaVigenciaDesde,
            fechaVigenciaHasta: props.data.entity.fechaVigenciaHasta,
            fechaBaja: props.data.entity.fechaBaja,
            superficie: props.data.entity.superficie,
            longitud: props.data.entity.longitud,
            idTipoConsumoElectrico: props.data.entity.idTipoConsumoElectrico,
            cantidadArtefactosElectricos: props.data.entity.cantidadArtefactosElectricos,
            numeroResolucion: props.data.entity.numeroResolucion,
            nombreEmbarcacion: props.data.entity.nombreEmbarcacion,
            matriculaEmbarcacion: props.data.entity.matriculaEmbarcacion,
            idTasaEmbarcacion: props.data.entity.idTasaEmbarcacion,
            idSubTasaEmbarcacion: props.data.entity.idSubTasaEmbarcacion,
            eslora: props.data.entity.eslora,
            manga: props.data.entity.manga,
            puntal: props.data.entity.puntal,
            pesoNeto: props.data.entity.pesoNeto,
            pesoBruto: props.data.entity.pesoBruto,
            pesoLastre: props.data.entity.pesoLastre
        });
        let esEmbarcacion = false;
        if (props.data.entity.idTipoArrendamiento !== 0) {
            const row = getRowEntidad('TipoArrendamiento', props.data.entity.idTipoArrendamiento);
            esEmbarcacion = (row) ? row.esEmbarcacion : false;
        }

        setState(prevState => {
            return {
                ...prevState,
                entity: props.data.entity,
                listEspaciosArrendado: props.data.listEspaciosArrendado,
                esEmbarcacion: esEmbarcacion
            }
        });
    }
    useEffect(mount, [props.data.entity, props.data.listEspaciosArrendado]);

    const [formValues, formHandle, , formSet] = useForm({
        idTipoArrendamiento: 0,
        numero: "",
        bloque: "",
        fechaVigenciaDesde: null,
        fechaVigenciaHasta: null,
        fechaBaja: null,
        superficie: 0,
        longitud: 0,
        idTipoConsumoElectrico: 0,
        cantidadArtefactosElectricos: 0,
        numeroResolucion: "",
        nombreEmbarcacion: "",
        matriculaEmbarcacion: "",
        idTasaEmbarcacion: 0,
        idSubTasaEmbarcacion: 0,
        eslora: 0,
        manga: 0,
        puntal: 0,
        pesoNeto: 0,
        pesoBruto: 0,
        pesoLastre: 0
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTipoArrendamiento = parseInt(formValues.idTipoArrendamiento);
        row.numero = formValues.numero;
        row.bloque = formValues.bloque;
        row.fechaVigenciaDesde = formValues.fechaVigenciaDesde;
        row.fechaVigenciaHasta = formValues.fechaVigenciaHasta;
        row.fechaBaja = formValues.fechaBaja;
        row.superficie = formValues.superficie;
        row.longitud = formValues.longitud;
        row.idTipoConsumoElectrico = parseInt(formValues.idTipoConsumoElectrico);
        row.cantidadArtefactosElectricos = parseInt(formValues.cantidadArtefactosElectricos);
        row.numeroResolucion = formValues.numeroResolucion;
        row.nombreEmbarcacion = formValues.nombreEmbarcacion;
        row.matriculaEmbarcacion = formValues.matriculaEmbarcacion;
        row.idTasaEmbarcacion = !isEmptyString(formValues.idTasaEmbarcacion) ? parseInt(formValues.idTasaEmbarcacion) : 0;
        row.idSubTasaEmbarcacion = !isEmptyString(formValues.idSubTasaEmbarcacion) ? parseInt(formValues.idSubTasaEmbarcacion) : 0;
        row.eslora = formValues.eslora;
        row.manga = formValues.manga;
        row.puntal = formValues.puntal;
        row.pesoNeto = formValues.pesoNeto;
        row.pesoBruto = formValues.pesoBruto;
        row.pesoLastre = formValues.pesoLastre;
        props.onConfirm(row);
    };

    const handleChangeEspacioArrendado = (event) => {
        const {target} = event;
        let idTipoArrendamiento = 0;
        let esEmbarcacion = false;
        if (target.row) {
            idTipoArrendamiento = parseInt(target.value);
            esEmbarcacion = target.row.esEmbarcacion;
        }

        if (idTipoArrendamiento === 0 || esEmbarcacion !== formValues.esEmbarcacion) {
            formSet({
                ...formValues,
                idTipoArrendamiento: idTipoArrendamiento,
                superficie: 0,
                longitud: 0,
                idTipoConsumoElectrico: 0,
                cantidadArtefactosElectricos: 0,
                numeroResolucion: "",
                nombreEmbarcacion: "",
                matriculaEmbarcacion: "",
                idTasaEmbarcacion: 0,
                idSubTasaEmbarcacion: 0,
                eslora: 0,
                manga: 0,
                puntal: 0,
                pesoNeto: 0,
                pesoBruto: 0,
                pesoLastre: 0
            });
        } else {
            formSet({
                ...formValues,
                idTipoArrendamiento: idTipoArrendamiento
            });
        }
        setState(prevState => {
            return {...prevState, esEmbarcacion: esEmbarcacion};
        });
    };


    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoArrendamiento <= 0) errors.idTipoArrendamiento = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.numero.length === 0) errors.numero = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (formValues.bloque.length === 0) errors.bloque = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (formValues.fechaVigenciaDesde === null) errors.fechaVigenciaDesde = VALIDATION_MESSAGE.REQUIRED_DATE;

        if (!state.esEmbarcacion && formValues.idTipoArrendamiento) {
            if (!isValidNumber(formValues.superficie, true)) errors.superficie = 'Ingresá un número mayor a cero';
            if (!isValidNumber(formValues.longitud, true)) errors.longitud = 'Ingresá un número mayor a cero';
            if (formValues.idTipoConsumoElectrico <= 0) errors.idTipoConsumoElectrico = VALIDATION_MESSAGE.REQUIRED_OPTION;
            if (isEmptyString(formValues.cantidadArtefactosElectricos)) errors.cantidadArtefactosElectricos = VALIDATION_MESSAGE.REQUIRED;
            else if (!isValidNumber(formValues.cantidadArtefactosElectricos, true)) errors.cantidadArtefactosElectricos = 'Ingresá un número mayor a cero';
            if (formValues.numeroResolucion.length === 0) errors.numeroResolucion = VALIDATION_MESSAGE.REQUIRED;
        }

        if (state.esEmbarcacion && formValues.idTipoArrendamiento) {
            if (formValues.matriculaEmbarcacion.length === 0) errors.matriculaEmbarcacion = VALIDATION_MESSAGE.REQUIRED;
            if (!isValidNumber(formValues.eslora, true)) errors.eslora = 'Ingresá un número mayor a cero';
            if (!isValidNumber(formValues.manga, true)) errors.manga = 'Ingresá un número mayor a cero';
            if (!isValidNumber(formValues.puntal, true)) errors.puntal = 'Ingresá un número mayor a cero';
            if (!isValidNumber(formValues.pesoNeto, true)) errors.pesoNeto = 'Ingresá un número mayor a cero';
            if (!isValidNumber(formValues.pesoBruto, true)) errors.pesoBruto = 'Ingresá un número mayor a cero';
            if (formValues.nombreEmbarcacion.trim().length === 0) errors.nombreEmbarcacion = VALIDATION_MESSAGE.REQUIRED;
            if (!isValidNumber(formValues.pesoLastre, true)) errors.pesoLastre = 'Ingresá un número mayor a cero';
        }

        return errors;
    }

    return (
        <Modal
            size="lg"
            title={`Espacio arrendado: ${(state.entity.id > 0) ? state.entity.numero : "Nuevo"}`}
            onEscape={() => props.onDismiss()}
            body={(<>
                            <div className="row">
                                <div className="mb-3 col-6 col-md-4">
                                    <FormLabel htmlFor="idTipoArrendamiento" required>Tipo arrendamiento</FormLabel>
                                    <InputEntidad
                                        name="idTipoArrendamiento"
                                        placeholder=""
                                        className={`form-control ${errorOf('idTipoArrendamiento') ? 'is-invalid' : ''}`}
                                        value={formValues.idTipoArrendamiento}
                                        onChange={handleChangeEspacioArrendado}
                                        disabled={props.disabled}
                                        title="Tipo arrendamiento"
                                        entidad="TipoArrendamiento"
                                    />
                                    <FormError message={errorOf('idTipoArrendamiento')} />
                                </div>
                                <div className="mb-3 col-6 col-md-4">
                                    <div className="d-flex gap-2">
                                        <div className="flex-fill">
                                            <FormLabel htmlFor="nroInterno" required>Número</FormLabel>
                                            <input
                                                name="numero"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('numero') ? 'is-invalid' : ''}`}
                                                value={formValues.numero}
                                                onChange={formHandle}
                                                disabled={props.disabled}
                                            />
                                            <FormError message={errorOf('numero')} />
                                        </div>
                                        <div className="flex-fill">
                                            <FormLabel htmlFor="nroDeclaracionJurada" required>Bloque</FormLabel>
                                            <input
                                                name="bloque"
                                                type="text"
                                                placeholder=""
                                                className={`form-control ${errorOf('bloque') ? 'is-invalid' : ''}`}
                                                value={formValues.bloque}
                                                onChange={formHandle}
                                                disabled={props.disabled}
                                            />
                                            <FormError message={errorOf('bloque')} />
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3 col-6 col-md-4">
                                    <FormLabel htmlFor="fechaVigenciaDesde" required>Vigente desde</FormLabel>
                                    <DatePickerCustom
                                        name="fechaVigenciaDesde"
                                        placeholder=""
                                        className={`form-control ${errorOf('fechaVigenciaDesde') ? 'is-invalid' : ''}`}
                                        value={formValues.fechaVigenciaDesde}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('fechaVigenciaDesde')} />
                                </div>
                                <div className="mb-3 col-6 col-md-4">
                                    <label htmlFor="fechaVigenciaHasta" className="form-label">Vigente hasta</label>
                                    <DatePickerCustom
                                        name="fechaVigenciaHasta"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.fechaVigenciaHasta}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                                <div className="mb-3 col-6 col-md-4">
                                    <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                    <DatePickerCustom
                                        name="fechaBaja"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.fechaBaja}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                            </div>

                            {formValues.idTipoArrendamiento > 0 &&
                                <>
                                    {!state.esEmbarcacion &&
                                        <>
                                            <div className="row">
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="superficie" required>Superficie</FormLabel>
                                                    <InputNumber
                                                        name="superficie"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('superficie') ? 'is-invalid' : ''}`}
                                                        value={formValues.superficie}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('superficie')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="longitud" required>Longitud</FormLabel>
                                                    <InputNumber
                                                        name="longitud"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('longitud') ? 'is-invalid' : ''}`}
                                                        value={formValues.longitud}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('longitud')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4">
                                                    <FormLabel htmlFor="idTipoConsumoElectrico" required>Tipo de consumo eléctrico</FormLabel>
                                                    <InputLista
                                                        name="idTipoConsumoElectrico"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('idTipoConsumoElectrico') ? 'is-invalid' : ''}`}
                                                        value={formValues.idTipoConsumoElectrico}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        lista="TipoConsumoElectrico"
                                                    />
                                                    <FormError message={errorOf('idTipoConsumoElectrico')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4">
                                                    <FormLabel htmlFor="cantidadArtefactosElectricos" required>Cantidad artefactos eléctricos</FormLabel>
                                                    <input
                                                        name="cantidadArtefactosElectricos"
                                                        type="number"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('cantidadArtefactosElectricos') ? 'is-invalid' : ''}`}
                                                        value={formValues.cantidadArtefactosElectricos}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('cantidadArtefactosElectricos')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="numeroResolucion" required>Número resolución</FormLabel>
                                                    <input
                                                        name="numeroResolucion"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('numeroResolucion') ? 'is-invalid' : ''}`}
                                                        value={formValues.numeroResolucion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('numeroResolucion')} />
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {state.esEmbarcacion &&
                                        <>
                                            <div className="row">
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="nombreEmbarcacion" required>Nombre
                                                        embarcación</FormLabel>
                                                    <input
                                                        name="nombreEmbarcacion"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('nombreEmbarcacion') ? 'is-invalid' : ''}`}
                                                        value={formValues.nombreEmbarcacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('nombreEmbarcacion')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="matriculaEmbarcacion" required>Matrícula embarcación</FormLabel>
                                                    <input
                                                        name="matriculaEmbarcacion"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('matriculaEmbarcacion') ? 'is-invalid' : ''}`}
                                                        value={formValues.matriculaEmbarcacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('matriculaEmbarcacion')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <label htmlFor="idTasaEmbarcacion" className="form-label">Tasa
                                                        embarcación</label>
                                                    <InputTasa
                                                        name="idTasaEmbarcacion"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.idTasaEmbarcacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        hideLoading
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <label htmlFor="idSubTasaEmbarcacion" className="form-label">Sub
                                                        tasa embarcación</label>
                                                    <InputSubTasa
                                                        name="idSubTasaEmbarcacion"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.idSubTasaEmbarcacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        idTasa={formValues.idTasaEmbarcacion}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="eslora" required>Eslora</FormLabel>
                                                    <InputNumber
                                                        name="eslora"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('eslora') ? 'is-invalid' : ''}`}
                                                        value={formValues.eslora}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('eslora')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="manga" required>Manga</FormLabel>
                                                    <InputNumber
                                                        name="manga"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('manga') ? 'is-invalid' : ''}`}
                                                        value={formValues.manga}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('manga')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="puntal" required>Puntal</FormLabel>
                                                    <InputNumber
                                                        name="puntal"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('puntal') ? 'is-invalid' : ''}`}
                                                        value={formValues.puntal}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('puntal')} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="pesoNeto" required>Peso neto</FormLabel>
                                                    <InputNumber
                                                        name="pesoNeto"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('pesoNeto') ? 'is-invalid' : ''}`}
                                                        value={formValues.pesoNeto}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('pesoNeto')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="pesoBruto" required>Peso bruto</FormLabel>
                                                    <InputNumber
                                                        name="pesoBruto"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('pesoBruto') ? 'is-invalid' : ''}`}
                                                        value={formValues.pesoBruto}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('pesoBruto')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="pesoLastre" required>Peso
                                                        lastre</FormLabel>
                                                    <InputNumber
                                                        name="pesoLastre"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('pesoLastre') ? 'is-invalid' : ''}`}
                                                        value={formValues.pesoLastre}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('pesoLastre')} />
                                                </div>
                                            </div>
                                        </>
                                    }
                                </>
                            }

                            <div className="mb-3 col-12">
                                <Accordion title="Información adicional">
                                    <DataTaggerFormRedux
                                        title="Información adicional de Espacio Arrendado"
                                        processKey={props.processKey}
                                        entidad="EspacioArrendado"
                                        idEntidad={state.entity.id}
                                        disabled={props.disabled}
                                    />
                                </Accordion>
                            </div>
            </>)}
            footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
            </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />
    );
}

EspacioArrendadoModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

EspacioArrendadoModal.defaultProps = {
    disabled: false
};

export default EspacioArrendadoModal;